<div class="new-reservation-container" [class.new-reservation-container--docked]="hasSelection"
  [class.new-reservation-container--results]="showChooseFlight && !noResults && !searchOpen">
  <app-expansion-panel class="reservation-search-panel" [opened]="true"
    [open]="openPanelObservable" [close]="closePanelObservable">
    <app-expansion-panel-header (click)="onSearchPanelToggle()">
      <span class="reservation-title">
        <span class="reservation-title__icon" aria-hidden="true"></span>
        <span>Faça uma nova reserva</span>
      </span>
    </app-expansion-panel-header>
    <app-expansion-panel-body>
      <app-flights-form [form]="flightsForm" (onSubmit)="searchFlights()" (filled)="getFlights()">
      </app-flights-form>
      @if (topRoutes.length > 0) {
        <section class="frequent-routes" aria-labelledby="frequent-routes-title"
          aria-describedby="frequent-routes-hint">
          <div class="frequent-routes__content">
            <div class="frequent-routes__heading">
              <span class="frequent-routes__heading-icon" aria-hidden="true"></span>
              <h3 class="frequent-routes__title" id="frequent-routes-title">Rotas frequentes</h3>
              <p class="frequent-routes__hint" id="frequent-routes-hint">
                Que tal voar novamente por uma das suas rotas frequentes?
              </p>
            </div>
            <div class="frequent-routes__list">
              @for (route of topRoutes; track routeKey(route)) {
                <button type="button" class="frequent-routes__card"
                  [class.frequent-routes__card--selected]="isRouteSelected(route)"
                  [attr.aria-pressed]="isRouteSelected(route)"
                  [attr.aria-label]="'Selecionar rota de ' + route.departure + ' para ' + route.arrival"
                  (click)="selectRoute(route)">
                  <span class="frequent-routes__plane" aria-hidden="true">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M21 16v-2l-8-5V3.5A1.5 1.5 0 0 0 11.5 2 1.5 1.5 0 0 0 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5z"/>
                    </svg>
                  </span>
                  <span class="frequent-routes__code">{{ route.departure }}</span>
                  <span class="frequent-routes__arrow" aria-hidden="true">→</span>
                  <span class="frequent-routes__code">{{ route.arrival }}</span>
                  <span class="frequent-routes__selected" aria-hidden="true">✓</span>
                </button>
              }
            </div>
          </div>
        </section>
      }
    </app-expansion-panel-body>
  </app-expansion-panel>

  @if (noResults && !flightsRequestStatus.loading) {
    <div class="reservation-status my-4" aria-live="polite">
      <div class="reservation-message reservation-message--empty" role="status">
        Nenhum voo encontrado para os critérios selecionados.
      </div>
    </div>
  }

  @if (showChooseFlight && outboundFlightsxc && !noResults) {
    <app-choose-flight [direction]="Direction.OUTBOUND" [flightsFormData]="flightsFormData"
      [flights]="outboundFlightsxc" [form]="chooseFlightForm"
      [proceeded]="proceeded" [searchCollapsed]="!searchOpen" (editSearch)="reopenSearch()">
    </app-choose-flight>
    @if (flightsFormData.isRoundTrip() && inboundFlightsxc) {
      <app-choose-flight [direction]="Direction.INBOUND" [flightsFormData]="flightsFormData"
        [flights]="inboundFlightsxc" [form]="chooseFlightForm"
        [proceeded]="proceeded">
      </app-choose-flight>
    }
    @if (hasSelection) {
      <div class="btn-proceed-container" aria-live="polite">
        <!-- Phones: "✓ IDA · LA3657/LA3560". Desktop adds the title, the icon and the route with times. -->
        <span class="selection-summary__icon" aria-hidden="true">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M21 16v-2l-8-5V3.5A1.5 1.5 0 0 0 11.5 2 1.5 1.5 0 0 0 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5z"/></svg>
        </span>
        <div class="selection-summary">
          <p class="selection-summary__title">{{ flightsFormData.isRoundTrip() ? 'Voos selecionados' : 'Voo selecionado' }}</p>
          <p class="selection-summary__leg">
            <span class="selection-summary__state" aria-hidden="true">{{ outboundSelection ? '✓' : '○' }}</span>
            <span class="selection-summary__direction">IDA</span>
            @if (outboundSelection) {
              <span class="selection-summary__route">{{ routeOf(outboundSelection) }}</span>
              <span class="selection-summary__flights">· {{ flightNumbers(outboundSelection) }}</span>
            } @else {
              <span class="selection-summary__flights">· Pendente</span>
            }
          </p>
          @if (flightsFormData.isRoundTrip()) {
            <p class="selection-summary__leg">
              <span class="selection-summary__state" aria-hidden="true">{{ inboundSelection ? '✓' : '○' }}</span>
              <span class="selection-summary__direction">VOLTA</span>
              @if (inboundSelection) {
                <span class="selection-summary__route">{{ routeOf(inboundSelection) }}</span>
                <span class="selection-summary__flights">· {{ flightNumbers(inboundSelection) }}</span>
              } @else {
                <span class="selection-summary__flights">· Pendente</span>
              }
            </p>
          }
        </div>
        @if (proceeded && pendingDirections.length) {
          <p class="proceed-pending" role="status">
            <span aria-hidden="true">⚠️</span>
            Falta escolher o voo de
            @for (pending of pendingDirections; track pending.name; let last = $last) {
              <strong>{{ pending.value }}</strong>@if (!last) { e }
            }
            para prosseguir.
          </p>
        }
        <button class="btn-proceed" type="button" [disabled]="flightsRequestStatus.isError" (click)="proceedReservation()">
          Prosseguir <span aria-hidden="true">→</span>
        </button>
      </div>
    }
  }

  @if (!showChooseFlight) {
    <div class="reservation-status my-4" aria-live="polite">
      @if (flightsRequestStatus.isLoading) {
        <app-loading></app-loading>
      }
      @if (flightsRequestStatus.isError && flightsRequestStatus.getErrorMessage()) {
        <div class="reservation-message reservation-message--error">
          ⚠️{{ flightsRequestStatus.getErrorMessage() }}
        </div>
      }
      @if (flightsRequestStatus.isNone && flightsIsEmpty()) {
        <div class="reservation-message reservation-message--empty">
          ⚠️ Não há voos disponíveis para origem/destino e período indicados.
        </div>
      }
    </div>
  }
</div>
